(function(){
  'use strict';

  angular.module('eclipseApp.checkout').factory('emailValidationService', ['$http', 'uteEndpoint', function($http, uteEndpoint){
    var emailValidation = {
      isEmailExistInJanrainAndCRM: function(emailAddress){
        return $http({
          url: uteEndpoint('v1/verifyExistingJanrainCustomer'),
          method: 'POST',
          params: { email: emailAddress },
          cache: false
        });
      }
    };
    return emailValidation;
  }]);

})();
